import { render, staticRenderFns } from "./MatchPaySuccessStep.vue?vue&type=template&id=33fcd4d0"
import script from "./MatchPaySuccessStep.vue?vue&type=script&lang=js"
export * from "./MatchPaySuccessStep.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports